import axios from 'axios'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {TOKEN_KEY} from '@/utils/constants'
import {getInstance} from '../services/auth0plugin'
import {auth} from '@/services/auth'
import {sendErrorReport, cleanSensitiveData, getJson} from '@/utils/utils'
import _ from 'lodash'
const api = axios.create({
  baseURL: process.env.VUE_APP_WEB_ROOT_URL
})

api.interceptors.request.use(
  async config => {
    const authService = getInstance()
    const token = await authService.getAccessTokenSilently()
    if (token) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      config.headers.Authorization = `Bearer ${token}`
      localStorage.setItem(TOKEN_KEY, token)
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  response => {
    // If the response is successful, just return the response
    return response
  },
  async error => {
    // send the error
    const response = error.response
    const requestBody = getJson(response.config.data)
    // remove password related keys for security
    const cleanRequestBody = cleanSensitiveData(requestBody)

    sendErrorReport({
      event: 'error:api',
      data: {
        method: error.config?.method || 'get',
        ..._.pick(response, 'url', 'status'),
        response_body: response.data,
        request_body: cleanRequestBody
      }
    })
    // Check if the error response status is 401
    if (error.response && error.response.status === 401) {
      auth.logout()
    }

    // If the error is not a 401, reject it
    return Promise.reject(error)
  }
)

export default api
